import React, { useState } from "react";
import comit from "../../Images/sexual helth image 1.jpg";
import  image1 from "../../Images/sadmanimage.webp"
import image2 from "../../Images/sexualhelthimages.webp";
import { FaHandHoldingHeart } from "react-icons/fa6";
import Servicelist from "../../commanfile/Servicelist";
import Button from "../../commanfile/Button";
import ServiceSlider from "../../commanfile/ServiceSlider";
import Iconehelthpage from "../../commanfile/Iconehelthpage";

const Sexualhelth = () => {
  const symtams1 = [
    "Decreased sexual desire or interest",
    "Difficulty in becoming or maintaining arousal",
    "Problems reaching orgasm or premature ejaculation",
    "Pain during sexual activity (e.g., vaginismus, dyspareunia)",
    
  ];
  const symtams = [
    "Relationship or communication issues affecting sexual intimacy",
    "Distress or dissatisfaction with sexual function or experience",
    "Sexual dysfunction linked to mental health issues or medication side effects",
    "Strange sensations (smells, tastes, or feelings)",
    
  ];

  const Data = [
    {
      question: "	Why is sexual health important for overall well-being?  ",
      answer: "	Sexual health is vital for overall well-being as it impacts physical health, emotional intimacy, self-esteem, and quality relationships, promoting a fulfilling life."
    },
    {
      question: "What are the most common sexual health problems people face? ",
      answer: "Common sexual health problems include erectile dysfunction, low libido, painful intercourse, premature ejaculation, and sexually transmitted infections."
    },
    {
      question: "Can stress or mental health issues affect sexual health?  ",
      answer: "	Stress and mental health problems can reduce desire, cause performance issues, and lead to sexual avoidance."
    },
    {
      question: "What is the link between sexual health and reproductive health? ",
      answer: "Sexual health and reproductive health are linked since sexual activity affects fertility, pregnancy, and infection prevention."
    }, {
      question: "When should I see a doctor about sexual health concerns?  ",
      answer: "	See a doctor if experiencing pain, persistent low libido, erectile dysfunction, difficulty conceiving, or unusual infections."
    },
    {
      question: "	Is it normal to have a low sex drive? ",
      answer: "	It is normal to have a fluctuating or low sex drive influenced by stress, hormones, or health."
    },
    {
      question: "Can lifestyle changes improve sexual health?  ",
      answer: "	Lifestyle changes such as exercise, healthy diet, stress control, and proper sleep improve sexual health."
    },
    {
      question: "How do chronic illnesses (like diabetes or heart disease) impact sexual health? ",
      answer: "Chronic illnesses may affect hormones, nerve function, circulation, and energy, impacting sexual function."
    },
    {
      question: "Are sexual health issues treatable? ",
      answer: "	Many sexual health issues are treatable with medication, therapy, and lifestyle changes."
    },
     {
      question: "Can medications cause sexual side effects? ",
      answer: "	Some medications, especially antidepressants and blood pressure drugs, cause sexual side effects."
    },
    {
      question: "How do I talk to my doctor about sexual health without feeling embarrassed? ",
      answer: "	Talk openly to your doctor; they are trained to discuss sexual health confidentially and professionally."
    },
    {
      question: "Is sexual health only about physical problems, or also about emotional well-being? ",
      answer: "	Sexual health includes physical function and emotional well-being, intimacy, satisfaction, and relationships."
    },
    {
      question: "What role does age play in sexual health?  ",
      answer: "Age influences hormones, desire, and function but sexual health can be maintained with proper care."
    },
       {
      question: "	Can relationship problems affect sexual health?  ",
      answer: "Relationship problems reduce intimacy, desire, and satisfaction."
    },
    {
      question: "What are some myths and misconceptions about sexual health?  ",
      answer: "Myths include that sexual problems are untreatable or reflect personal failure."
    }, {
      question: "Is it safe to use over-the-counter products for sexual problems?   ",
      answer: "OTC products may be unsafe or ineffective; consult a healthcare provider before use."
    },
    {
      question: "How does counseling or therapy help in sexual health concerns?  ",
      answer: "Counseling addresses emotional, psychological, and relational sexual health concerns."
    },
    {
      question: "What are the warning signs of a serious sexual health issue?  ",
      answer: "Warning signs include persistent pain, bleeding, lumps, sudden loss of function, or infection signs."
    },
    {
      question: "How can couples work together to improve their sexual health?  ",
      answer: "Couples improve sexual health by communicating openly, respecting each other, solving problems together, and seeking help when needed."
    },
  ]

  const [isOpen, setisOpen] = useState("null")

  const togglefaqs = (index) => {
    setisOpen(isOpen === index ? null : index)
  }

  return (
    <>
      <div className="max-w-[1456px]  mx-auto ">
        <div className="border-b-4  pb-8 ">
          <ServiceSlider
            classname={"sm:flex  items-center  flex-row-reverse px-2"}
            title={"Sexual Health"}
            content={
              "Sexual health is an important part of overall well-being, yet it is often surrounded by silence and stigma. "
            }
            maincontent={"It is not something to be ashamed of, but something to be understood, respected, and cared for. Seeking help for sexual health concerns is a sign of strength, not weakness. With the right guidance and treatment, challenges can be overcome, relationships can thrive, and confidence can be restored. Remember, your sexual health is just as important as your physical and mental health—and you are never alone in caring for it."            }
            buttonname={"Explore Treatment Option "}
            imgs={image2}
          />
        </div>
        <div className="py-16  px-2">
          <div className="text-center ">
            <p className="font-roboto text-3xl line-clamp-5 ">
             Sexual health related problems typically appear as:
          
            </p>
            <div className="lg:flex mx-auto justify-around py-8 items-center ">
              <div className=" ">
                <img
                  src={image1}
                  className="border-black mx-auto rounded-2xl h-[300px] w-[300px]"
                />
              </div>
              <div>
                <div className="sm:flex px-5 justify-between mx-auto gap-14 ">
                  <div className=" ">
                    <Servicelist Symtams={symtams} />
                  </div>
                  <div className="">
                    <Servicelist Symtams={symtams1} />
                  </div>
                </div>
                <div className="mx-auto pt-10 ">
                  <Button
                    className={
                      "text-black hover:text-white font-roboto text-[20px] text-center items-center bg-[#50b1a4] p-1 rounded-full h-[40px] w-[200px]"
                    }
                    btnName={"Get Appointment"}
                    link={"/ContactUs"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto py-3">
          <div className="sm:flex justify-around pt-5 items-center">
            <div className="sm:w-[50%] w-full  ">
              <p className=" flex gap-2  px-2 font-roboto text-3xl uppercase text-[#469B8F]">
                   <FaHandHoldingHeart />
                Our assurance of compassionate care
              </p>

              <p className="mx-auto text-justify text-lg py-3 px-5">
                At Psynexa, we provide a safe, respectful, and confidential
                space to address a wide range of sexual health concerns with the
                guidance of experienced psychiatrists.
              </p>
              <p className="mx-auto text-justify text-lg py-2 px-5">
                Our team treats conditions like Hypoactive Sexual Desire
                Disorder, Premature Ejaculation, and Infertility, combining
                medical care with emotional support. We also help individuals
                manage Dhat Syndrome, rooted in anxiety about semen loss, and
                Erectile Dysfunction, offering solutions that restore both
                confidence and function.
              </p>
              <p className="mx-auto text-justify text-lg py-2 px-5">
                Understanding the deeply personal nature of these issues, we
                offer personalized treatment plans that may include therapy,
                medication, or counseling. Our goal is to enhance both emotional
                well-being and physical intimacy through a compassionate,
                integrated approach.
              </p>
            </div>
            <div className="">
              <img
                src={comit}
                className="w-[500px] h-[500px] "
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="bg-[#e7f2f2] px-10">
          <Iconehelthpage/>
        </div>

        <div className="mx-auto md:pl-[40px] md:pr-[40px] p-2 pt-10">
          <div className="mx-auto">
            <p className="text-2xl font-bold text-center font-roboto">FAQs</p>
          </div>
          <div className="space-y-4 mt-4">
            {Data.map((faq, index) => (
              <div key={index} className="border border-gray-200 w-[100%] mx-auto rounded-lg">
                <button
                  onClick={() => togglefaqs(index)}
                  className="w-full text-left px-4 py-3 flex justify-between items-center focus:outline-none"
                >
                  <span className="font-medium font-roboto">{faq.question}</span>
                  <span>{isOpen === index ? '-' : '+'}</span>
                </button>
                {isOpen === index && (
                  <div className="px-4 py-2 font-roboto text-justify text-gray-600">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sexualhelth;
